/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RotatedObservabilityKey = {
  /**
   * When this key stops authenticating. A key already inside a shorter grace window keeps its earlier deadline, so this can precede the rotation's own deadline. Absent when the key was revoked immediately.
   */
  expiresAt?: Date | undefined;
  /**
   * The API key ID.
   */
  id: string;
  /**
   * The recognizable prefix of the previous key.
   */
  keyPrefix: string;
  /**
   * The API key name.
   */
  name: string;
};

/** @internal */
export const RotatedObservabilityKey$inboundSchema: z.ZodMiniType<
  RotatedObservabilityKey,
  unknown
> = z.pipe(
  z.object({
    expires_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    id: z.string(),
    key_prefix: z.string(),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "expires_at": "expiresAt",
      "key_prefix": "keyPrefix",
    });
  }),
);

export function rotatedObservabilityKeyFromJSON(
  jsonString: string,
): SafeParseResult<RotatedObservabilityKey, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RotatedObservabilityKey$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RotatedObservabilityKey' from JSON`,
  );
}
